import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AzureAD, {
  IAzureADFunctionProps,
  AuthenticationState,
} from "react-aad-msal";
import { AuthProvider } from "./AuthProvider";
import { store } from ".";
import NominationListPage from "./components/nominations/NominationList";
import Header from "./components/common/Header";
import DashboardPage from "./components/dashboard/DashboardPage";
import LogoutPage from "./components/common/Logout";
import SofPage from "./components/sof/SofPage";
import "office-ui-fabric-react/dist/css/fabric.css";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import Sidebar from "./components/common/Sidebar";
import LoginPage from "./components/common/LoginPage";
import SignOutPage from "./components/common/SignOut";
import { loadTheme } from "@fluentui/react";
import { ToastContainer } from "react-toastify";
import ReportPage from "./components/reports/ReportPage";
import "react-toastify/dist/ReactToastify.css";
import HelpIndex from "./components/help";
import ReleaseNotesPage from "./components/help/ReleaseNotes";
import ReviewSoF from "./components/sof/ReviewSoF";
import WorkPacketList from "./components/dwp/WorkPacketList";
import WorkPacketFormComponent from "./components/dwp/WorkPacketForm";
import PrintPreview from "./components/dwp/PrintPreview";
import ServicesList from "./components/services/ServicesList";
import ServicesGroup from "./components/services/ServicesGroup";
import ServicesGroupFolder from "./components/services/ServicesGroupFolder";
import TruckNominationListPage from "./components/truck/nomination/NominationListPage";
import TruckSofPage from "./components/truck/TruckSofPage";
import TankNominationListPage from "./components/tank/nomination/NominationListPage";
import TankSofPage from "./components/tank/TankSofPage";
import NominationTruckRejection from "./components/truck/nomination/NominationTruckRejection";
import NominationRailRepair from "./components/truck/nomination/NominationRailRepair";
import InvoicePage from "./components/invoices/InvoicePage";
import OperatorDashboard from "./components/dashboard/OperatorDashboard";
import CustomerLoginPage from "./components/common/CustomerLoginPage";
import CustomerSidebar from "./components/common/CustomerSidebar";

import "./variables.css";
import "./App.css";
import "react-datetime/css/react-datetime.css";
import OrdersPage from "./components/order/OrdersPage";
import OrdersDetails from "./components/order/OrdersDetails";

const App: React.FC = () => {
  initializeIcons();
  loadTheme({
    palette: {
      themePrimary: "#00aeef",
      themeLighterAlt: "#f4fcfe",
      themeLighter: "#d4f2fd",
      themeLight: "#afe6fa",
      themeTertiary: "#62cef6",
      themeSecondary: "#1db9f2",
      themeDarkAlt: "#009ed8",
      themeDark: "#0086b6",
      themeDarker: "#006286",
      neutralLighterAlt: "#faf9f8",
      neutralLighter: "#f3f2f1",
      neutralLight: "#edebe9",
      neutralQuaternaryAlt: "#e1dfdd",
      neutralQuaternary: "#d0d0d0",
      neutralTertiaryAlt: "#c8c6c4",
      neutralTertiary: "#a19f9d",
      neutralSecondary: "#605e5c",
      neutralPrimaryAlt: "#3b3a39",
      neutralPrimary: "#323130",
      neutralDark: "#201f1e",
      black: "#000000",
      white: "#ffffff",
    },
  });

  return (
    <AzureAD provider={AuthProvider} reduxStore={store.store}>
      {(a: IAzureADFunctionProps) => {
        if (window.location.href.includes("custlogin"))
          return (
            <div className="App">
              <Switch>
                <Route exact path="/custlogin" component={CustomerLoginPage} />
              </Switch>
            </div>
          );
        else if (window.location.href.includes("customer"))
          return (
            <>
              <div className="App">
                <ToastContainer
                  position="bottom-right"
                  autoClose={5000}
                  hideProgressBar
                  newestOnTop={false}
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className="left-pane">
                  <CustomerSidebar />
                </div>
                {/* <Header /> */}

                <main id="main" role="main" className="main-pane">
                  <div
                    style={{
                      position: "relative",
                      background: "white",
                      top: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Switch>
                      <Route exact path="/customer" component={DashboardPage} />
                      <Route path="/customer/invoice" component={InvoicePage} />
                      <Route
                        path="/customer/order/:orderNo/details"
                        component={OrdersDetails}
                      />
                      <Route path="/customer/order" component={OrdersPage} />

                      <Route path="/logout" component={LogoutPage} />
                      <Route path="/signout" component={SignOutPage} />
                      <Route path="/help" component={HelpIndex} />
                      <Route path="/change-log" component={ReleaseNotesPage} />
                    </Switch>
                  </div>
                </main>
              </div>
            </>
          );
        else if (a.authenticationState === AuthenticationState.Authenticated)
          return (
            <>
              <div className="App">
                <ToastContainer
                  position="bottom-right"
                  autoClose={5000}
                  hideProgressBar
                  newestOnTop={false}
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className="left-pane">
                  <Sidebar />
                </div>
                <Header />

                <main id="main" role="main" className="main-pane">
                  <div
                    style={{
                      position: "relative",
                      background: "white",
                      top: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Switch>
                      {/* if operator */}
                      <Route exact path="/" component={OperatorDashboard} />
                      {/* if customer */}
                      <Route
                        exact
                        path="/customer/"
                        component={DashboardPage}
                      />
                      <Route
                        exact
                        path="/marine"
                        component={NominationListPage}
                      />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/sof"
                        component={SofPage}
                      />
                      <Route path="/review" component={ReviewSoF} />
                      <Route path="/logout" component={LogoutPage} />
                      <Route path="/signout" component={SignOutPage} />
                      <Route path="/reports" component={ReportPage} />
                      <Route path="/help" component={HelpIndex} />
                      <Route path="/customer/invoice" component={InvoicePage} />
                      <Route path="/change-log" component={ReleaseNotesPage} />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/work-packets"
                        component={WorkPacketList}
                      />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/work-packet/:workPacketId"
                        component={WorkPacketFormComponent}
                      />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/work-packet/:workPacketId/preview"
                        component={PrintPreview}
                      />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/services"
                        component={ServicesList}
                      />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/services/group/"
                        component={ServicesGroup}
                      />
                      <Route
                        exact
                        path="/marine/:lineHandlingNo/services/group/:groupName"
                        component={ServicesGroupFolder}
                      />
                      <Route
                        key="tankNominationList"
                        exact
                        path="/tank"
                        component={TankNominationListPage}
                      />
                      <Route
                        exact
                        path="/tank/:nominationNo/sof"
                        component={TankSofPage}
                      />
                      <Route
                        key="truckNominationList"
                        exact
                        path="/truck"
                        component={TruckNominationListPage}
                      />
                      <Route
                        exact
                        path="/truck/:lineHandlingNo/sof"
                        component={TruckSofPage}
                      />

                      <Route
                        exact
                        path="/truck/:nominationNo/sof/rejection"
                        component={NominationTruckRejection}
                      />

                      <Route
                        exact
                        path="/rail/:nominationNo/sof/:repairType/repair"
                        component={NominationRailRepair}
                      />

                      <Route
                        exact
                        path="/truck/:lineHandlingNo/work-packets"
                        component={WorkPacketList}
                      />
                      <Route
                        exact
                        path="/truck/:lineHandlingNo/work-packet/:workPacketId"
                        component={WorkPacketFormComponent}
                      />
                      <Route
                        exact
                        path="/truck/:lineHandlingNo/work-packet/:workPacketId/preview"
                        component={PrintPreview}
                      />
                      <Route
                        exact
                        path="/truck/:lineHandlingNo/services"
                        component={ServicesList}
                      />
                      <Route
                        exact
                        path="/truck/:lineHandlingNo/services/group/"
                        component={ServicesGroup}
                      />
                      <Route
                        exact
                        path="/truck/:lineHandlingNo/services/group/:groupName"
                        component={ServicesGroupFolder}
                      />

                      <Route
                        key="railNominationList"
                        exact
                        path="/rail"
                        component={TruckNominationListPage}
                      />
                      <Route
                        exact
                        path="/rail/:lineHandlingNo/sof"
                        component={TruckSofPage}
                      />
                      <Route
                        exact
                        path="/rail/:nominationNo/sof/rejection"
                        component={NominationTruckRejection}
                      />

                      <Route
                        exact
                        path="/rail/:lineHandlingNo/work-packets"
                        component={WorkPacketList}
                      />
                      <Route
                        exact
                        path="/rail/:lineHandlingNo/work-packet/:workPacketId"
                        component={WorkPacketFormComponent}
                      />
                      <Route
                        exact
                        path="/rail/:lineHandlingNo/work-packet/:workPacketId/preview"
                        component={PrintPreview}
                      />
                      <Route
                        exact
                        path="/rail/:lineHandlingNo/services"
                        component={ServicesList}
                      />
                      <Route
                        exact
                        path="/rail/:lineHandlingNo/services/group/"
                        component={ServicesGroup}
                      />
                      <Route
                        exact
                        path="/rail/:lineHandlingNo/services/group/:groupName"
                        component={ServicesGroupFolder}
                      />
                    </Switch>
                  </div>
                </main>
              </div>
            </>
          );
        else
          return (
            <div className="App">
              <Switch>
                <Route exact path="/" component={LoginPage} />
                <Route render={() => <Redirect to="/" />} />
              </Switch>
            </div>
          );
      }}
    </AzureAD>
  );
};

export default App;
